import React from "react";
import assets from "../../../shared/constants/assetVariables";
import { NavLink, withRouter } from "react-router-dom";
import "../SCSS/styles.css";

function GetFreeTrialBanner() {
  return (
    <section
      className="get-demo"
      style={{
        backgroundImage: `-webkit-linear-gradient(#4147db00, #414adbed), url(${assets.images.footerDemoBackground})`,
      }}
      //style={{ backgroundImage: `url(${assets.images.footerDemoBackground})` }}
    >
      <div className="demo-container">
        <div className="demo-section-title-wrapper">
          <h2 className="demo-section-title">
            Are you ready to start your sustainability journey with an
            easy-to-use SaaS-based ESG data management, reporting & analytical
            tool? Get a Free Trial Today.
          </h2>
        </div>
        <div className="demo-section-button-wrapper">
          <NavLink to="/free-trial" className="demo-section-button">
            Book a free trial
          </NavLink>
        </div>
      </div>
    </section>
  );
}

export default withRouter(GetFreeTrialBanner);
